import { axiosInstance } from './ApiConfig';

async function fetchPdp(pdc) {
  const request = JSON.stringify({
    pdc: pdc,
  });

  const response = await axiosInstance({
    method: 'POST',
    url: '/pdp',
    data: request,
  });

  if (response.status !== 200) {
    throw new Error('Failed to fetch PDP data');
  }

  return response.data.value;
}

async function FetchPdp(pdc, setInputs, setInitFetchPdp) {
  try {
    const result = await fetchPdp(pdc);
    const modifiedResult = result.map((item) => ({
      ...item,
      selected: true,
    }));
    setInputs((prevInputs) => ({
      ...prevInputs,
      pdp: modifiedResult,
    }));
    setInitFetchPdp(true);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

export default FetchPdp;
